import { DealerConsoleAction, FlagStateType } from './baccarat-enums.model';
import { ChatMessageEvent } from './baccarat-events.model';
import { Json } from '../types.model';

export enum BaccaratRequestType {
    DealerAction = 'dealer-action',
    GetChatMessages = 'get-chat-messages',
    SetFlagState = 'set-flag-state'
}

export interface DealerActionRequestMessage extends Json {
    action: DealerConsoleAction;
}

export interface SetFlagStateRequestMessage extends Json {
    flag: FlagStateType;
    state: boolean;
}

export interface GetChatMessagesResponseMessage extends Json {
    messages: ChatMessageEvent[];
}
